export default {
  common: {
    search: '搜索',
    reset: '重置',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    submit: '提交',
    add: '添加',
    edit: '编辑',
    view: '查看',
    delete: '删除',
    enabled: '启用',
    disabled: '禁用',
    invalidate: '作废',
    actions: '操作',
    status: '状态',
    created: '创建时间',
    updated: '更新时间',
    years: '{n} 年',
    months: '{n} 个月',
    yearUnit: '年',
    monthUnit: '个月',
    yes: '是',
    no: '否',
    all: '全部',
    keyword: '关键词',
    unknown: '未知',
    none: '无',
    noData: '暂无数据',
    error: '错误',
    requestError: '请求错误',
    pleaseSelect: '请选择',
    pleaseEnter: '请输入',
    copy: '复制',
    copiedToClipboard: '已复制到剪贴板',
    uploadSizeHint: '单文件不超过 {n}MB',
    fileTooLarge: '文件过大，最大支持 {n}MB',
    requestTooLarge: '上传内容过大，请压缩至 {n}MB 以内再试',
    lastLogin: '最后登录',
    language: '语言',
    english: 'English',
    chinese: '中文',
    logout: '退出登录',
    changeEmail: '修改邮箱',
    sendCode: '发送验证码',
    verificationCode: '验证码',
    description: '描述',
    remark: '备注',
    address: '地址',
    phone: '电话',
    contact: '联系人',
    code: '编号',
    name: '名称',
    type: '类型',
    price: '价格',
    min: '最低',
    max: '最高',
    startDate: '开始日期',
    endDate: '结束日期',
    selectDate: '选择日期',
    sort: '排序',
    sales: '销量',
    detail: '详情',
    pending: '待处理',
    completed: '已完成',
    archived: '已归档',
    approved: '已通过',
    rejected: '已拒绝',
    active: '质保中',
    expired: '已过期',
    voided: '已作废',
    on: '上架',
    off: '下架',
    product: '产品',
    service: '服务',
    package: '套餐',
    agent: '代理商',
    loadingFailed: '加载失败',
    savedSuccessfully: '保存成功',
    updatedSuccessfully: '更新成功',
    createdSuccessfully: '创建成功',
    deletedSuccessfully: '删除成功',
    operationFailed: '操作失败',
    batchNoteUpdatedSuccessfully: '批次备注更新成功',
    uploadImage: '上传图片',
    uploading: '上传中...',
    uploadFailed: '上传失败'
  },
  status: {
    onSale: '上架',
    offSale: '下架',
    registered: '已有登记记录',
    unregistered: '暂无登记记录',
    invalid: '已作废',
    pendingReview: '待审核',
    onHold: '暂缓审核',
    active: '已激活',
    rejected: '未通过'
  },
  validation: {
    required: '此项为必填项',
    requiredEmail: '请输入邮箱',
    requiredCode: '请输入验证码',
    invalidEmail: '邮箱格式不正确',
    codeLength6: '验证码为6位数字',
    requiredUsername: '请输入用户名',
    requiredNickname: '请输入昵称',
    requiredOwnerName: '请输入车主姓名',
    requiredStoreName: '请输入门店名称',
    requiredLoginEmail: '请输入登录邮箱',
    requiredAgent: '请选择代理商',
    requiredMember: '请选择车主',
    requiredStore: '请选择门店',
    requiredCategory: '请选择产品类型',
    requiredModel: '请选择产品型号',
    requiredProductName: '请输入产品名称',
    requiredProductCode: '请输入产品编码',
    requiredProductType: '请选择产品类型',
    requiredSalePrice: '请输入售价',
    requiredStatus: '请选择状态',
    requiredPlateNumber: '请输入车牌号',
    requiredEmployeeName: '请输入员工姓名',
    requiredEmployeeId: '请输入工号',
    requiredQuantity: '请输入数量',
    requiredWarrantyYears: '请输入质保期限',
    requiredTypeCode: '请输入编码',
    requiredTypeName: '请输入名称',
    requiredModelColorName: '请输入型号/颜色名称',
    typeCodePattern: '只能是大写字母、数字、-、_',
    requiredPageCode: '请输入页面代码',
    requiredPageTitle: '请输入页面标题',
    requiredPageContent: '请输入页面内容',
    requiredFields: '请填写必填字段'
  },
  toast: {
    created: '创建成功',
    updated: '更新成功',
    deleted: '删除成功',
    saved: '保存成功',
    exported: '导出成功',
    exportFailed: '导出失败',
    loginSuccessful: '登录成功',
    codeSent: '验证码已发送',
    codeSendFailed: '发送验证码失败',
    loginFailed: '登录失败',
    emailChanged: '邮箱修改成功',
    emailChangeFailed: '邮箱修改失败',
    approved: '审批通过成功',
    rejected: '拒绝成功',
    invalidated: '作废成功',
    generated: '成功生成 {n} 个序列号',
    generateFailed: '生成序列号失败',
    copied: '已复制到剪贴板',
    settingsSaved: '设置保存成功'
  },
  menu: {
    group: {
      dashboard: '首页',
      customerInfo: '客户信息',
      agency: '代理机构',
      productInfo: '产品信息',
      website: '网站页面',
      profile: '修改邮箱'
    }
  },
  route: {
    dashboard: '仪表盘',
    myProducts: '我的产品',
    warrantySummary: '质保汇总',
    warrantyRegister: '质保登记',
    warranties: '质保档案',
    vehicles: '车辆档案',
    members: '车主档案',
    stores: '门店管理',
    storeEmployees: '门店员工',
    agents: '代理商管理',
    products: '产品管理',
    cmsPages: '网站页面',
    websiteCategories: '产品分类',
    websiteProducts: '网站产品',
    websiteInstallations: '实车案例',
    websiteColors: '颜色库',
    websiteArticles: '洞察与新闻',
    websiteAbout: '关于页',
    traceCategories: '产品类型管理',
    traceSpecifications: '产品型号管理',
    traceCodes: '我的产品',
    traceInstallationAreas: '安装部位管理',
    tracePackages: '套装方案管理',
    settings: '系统设置',
    profile: '修改邮箱'
  },
  website: {
    common: {
      name: '名称',
      nameEn: '英文名称',
      image: '图片',
      slug: 'Slug',
      tabZh: '中文',
      tabEn: 'English',
      slugRequired: '请输入 Slug',
      slugPattern: 'Slug 仅支持小写字母、数字和连字符',
      nameRequired: '请输入名称',
      deleteConfirm: '确定删除 "{name}" 吗？'
    },
    categories: {
      title: '产品分类管理',
      list: '分类列表',
      add: '添加分类',
      edit: '编辑分类',
      keywordPlaceholder: '名称 / Slug',
      summary: '分类简介',
      summaryEn: '英文简介'
    },
    products: {
      title: '网站产品管理',
      list: '产品列表',
      add: '添加产品',
      edit: '编辑产品',
      keywordPlaceholder: '名称 / Slug',
      category: '所属分类',
      categoryRequired: '请选择所属分类',
      featured: '首页精选',
      featuredTag: '精选',
      descriptor: '一句话描述',
      descriptorEn: '英文描述',
      effect: '效果描述',
      effectEn: '英文效果',
      installation: '施工建议',
      installationEn: '英文施工建议',
      care: '养护建议',
      careEn: '英文养护建议',
      warranty: '质保说明',
      warrantyEn: '英文质保说明',
      seriesSection: '系列与型号',
      seriesName: '系列名称',
      addSeries: '添加系列',
      modelCode: '型号编码',
      modelDesc: '型号描述',
      modelThickness: '标称厚度',
      addModel: '添加型号',
      variantsSection: '型号变体（VLT）',
      addVariant: '添加变体',
      advantagesSection: '产品优势',
      addAdvantage: '添加优势',
      applicationsSection: '适用部位',
      addApplication: '添加适用部位',
      specsSection: '规格参数',
      specLabel: '参数名',
      specValue: '参数值',
      addSpec: '添加规格'
    },
    installations: {
      title: '实车案例管理',
      list: '案例列表',
      add: '添加案例',
      edit: '编辑案例',
      keywordPlaceholder: '标题 / 车型 / Slug',
      vehicle: '车辆',
      color: '关联颜色',
      products: '关联产品',
      titleField: '案例标题',
      titleEn: '英文标题',
      caption: '案例说明',
      captionEn: '英文说明',
      area: '施工部位',
      areaEn: '英文施工部位',
      make: '品牌',
      model: '型号',
      year: '年款'
    },
    colors: {
      title: '颜色库管理',
      list: '颜色列表',
      add: '添加颜色',
      edit: '编辑颜色',
      keywordPlaceholder: '名称 / 编码 / Slug',
      code: '颜色编码',
      codeRequired: '请输入颜色编码',
      collection: '所属系列',
      collectionEn: '英文系列',
      family: '色系',
      familyEn: '英文色系',
      description: '颜色描述',
      descriptionEn: '英文描述',
      products: '关联产品'
    },
    articles: {
      title: '洞察与新闻管理',
      list: '文章列表',
      add: '添加文章',
      edit: '编辑文章',
      keywordPlaceholder: '标题 / 栏目 / Slug',
      type: '类型',
      typeRequired: '请选择类型',
      insight: '洞察',
      news: '新闻',
      category: '栏目',
      categoryEn: '英文栏目',
      excerpt: '摘要',
      excerptEn: '英文摘要',
      readTime: '阅读时长',
      readTimeEn: '英文阅读时长',
      publishDate: '发布日期',
      products: '关联产品',
      bodySection: '正文段落',
      section: '段落',
      headingZh: '小标题（中文）',
      headingEn: '小标题（英文）',
      textZh: '正文（中文）',
      textEn: '正文（英文）',
      addSection: '添加段落'
    },
    about: {
      title: '关于页管理',
      tip: '提示',
      tipText: '此处编辑网站"关于我们"整页内容，中文与英文各一份；英文留空时网站端自动回退显示中文。',
      pageTitle: '页面标题',
      content: '页面内容'
    }
  },
  login: {
    title: 'Auto Care Admin',
    emailPlaceholder: '邮箱',
    codePlaceholder: '6位验证码',
    login: '登录',
    sessionExpired: '登录已过期，请重新登录。',
    sessionExpiredResent: '登录已过期，新的验证码已发送至您的邮箱，请重新登录。',
    portalTitle: '登录业务平台',
    portalSubtitle: '使用您的邮箱获取验证码并登录',
    emailLabel: '邮箱地址',
    codeLabel: '验证码',
    sendCodeHint: '验证码将发送至您的邮箱。',
    applyDealer: '申请成为合作伙伴',
    backToSite: '返回官网',
    footerBrand: 'SCOTT NOLES · 业务平台'
  },
  warrantyRegister: {
    openTip: '质保登记在官网完成。点击下方按钮将在新标签页打开注册页面；如未自动打开，请检查浏览器弹窗拦截设置。',
    openButton: '打开质保登记页面',
    ownerEmail: '车主邮箱',
    ownerName: '车主姓名',
    ownerPhone: '车主电话',
    installDate: '安装日期',
    vehicleInfo: '车辆信息',
    plateNumber: '车牌号',
    vehicleState: '州/省',
    vehicleStatePlaceholder: '车牌签发州/省',
    vehicleStateHint: '填写车牌时请同步填写签发地区；当地车牌按州/省编号时用于区分',
    vinCode: 'VIN码',
    brand: '品牌',
    model: '型号',
    color: '颜色',
    technician: '安装技师',
    traceCodes: '序列号',
    traceCodePlaceholder: '请输入序列号，多个可用换行、逗号、分号或空格分隔',
    traceCodeTip: '同一辆车和车主可一次性注册多个序列号。',
    submit: '质保登记',
    submitSuccess: '质保登记已提交，等待管理员审核',
    submitFailed: '质保登记失败',
    successTitle: '提交成功',
    successSubtitle: '已提交 {count} 条质保登记，等待管理员审核批准',
    continueRegister: '继续注册',
    ownerEmailRequired: '请输入车主邮箱',
    ownerEmailInvalid: '邮箱格式不正确',
    ownerNameRequired: '请输入车主姓名',
    installDateRequired: '请选择安装日期',
    traceCodesRequired: '请至少输入一个序列号'
    ,
    tabVerify: '产品验证',
    tabDetails: '填写质保',
    tabConfirm: '确认登记',
    verifyTitle: '验证序列号',
    verifyPlaceholder: '请输入序列号',
    verifyButton: '验证',
    verifyTip: '请输入序列号逐一验证，验证通过的产品将进入本次登记。',
    verifiedList: '本次登记产品',
    nextToDetails: '下一步：填写质保信息',
    verifyNoCode: '请先验证至少一个有效序列号',
    status0: '暂无登记记录',
    status1: '已有登记记录',
    status2: '已作废',
    statusSuspended: '已冻结',
    statusNotEligible: '不可登记',
    verifyFailed: '序列号验证失败',
    duplicatedCode: '该序列号已在列表中，请勿重复验证',
    alreadyRegisteredTip: '该序列号已注册过质保，可重复登记，将由管理员复核。',
    registrationStats: '已登记 {n} 次，最近登记时间：{time}',
    invalidCodeTip: '该序列号已作废，无法登记。',
    notEligibleTip: '该产品类别不支持质保登记，无法提交。',
    productName: '产品名称',
    spec: '产品属性',
    attrMaterial: '材质',
    attrFinish: '工艺',
    attrColor: '颜色',
    attrThickness: '厚度',
    warrantyPeriod: '质保期',
    batchNo: '批次号',
    finishColor: '表面/颜色',
    sectionCustomer: '车主信息',
    sectionVehicle: '车辆与安装信息',
    emailHint: '用于接收审核结果，批准后发送电子证书',
    installDateHint: '不能晚于当前日期',
    vinHint: '选填，最多 17 位',
    requiredNote: '* 仅车主邮箱和安装日期必填，其余信息均为选填',
    backToVerify: '返回产品验证',
    nextToConfirm: '下一步：确认登记',
    backToEdit: '返回修改',
    confirmSubmit: '确认提交',
    confirmTitle: '请核对以下登记信息',
    confirmProducts: '本次登记产品',
    confirmCustomer: '车主信息',
    confirmVehicle: '车辆与安装信息',
    noData: '未填写',
    sectionProductInstall: '产品方案与安装信息',
    stepProductType: '选择产品类型',
    productTypeHint: '产品类型取自数据库"产品大类"，请按实际施工产品选择。',
    noCategories: '暂无启用中的产品类型',
    // 专项防护等一级分类需先选二级产品（如 大灯保护膜 / 玻璃遁甲保护膜）
    stepPackage: '选择套装方案',
    pkgFull: '全车保护套装',
    pkgFront: '前部保护套装',
    pkgRear: '后部保护套装',
    pkgCustom: '自选部位',
    pkgClear: '清除',
    sideLeft: '左侧',
    sideRight: '右侧',
    sideBoth: '两侧',
    selectSide: '选择左右位置',
    stepAreas: '确认具体部位',
    noAreasSelected: '尚未选择安装部位',
    areasSelectedPrefix: '已选择',
    areasHint: '套装会自动勾选所含部位，仍可继续增减；涉及左右的部位可以选择左侧、右侧或两侧。',
    stepVehicle: '填写车辆与安装资料',
    technicians: '安装技师',
    techniciansPlaceholder: '选择或输入技师姓名',
    techniciansHint: '可多选门店技师，也可新增临时技师',
    sectionPhotos: '照片与凭证',
    photosOptional: '全部选填',
    receiptLabel: '订单或凭证',
    receiptHint: 'JPG、PNG 或 PDF，单文件不超过 5MB',
    beforePhotos: '安装前照片',
    beforePhotosHint: '支持多张，单张不超过 5MB',
    afterPhotos: '安装后照片',
    afterPhotosHint: '支持多张，单张不超过 5MB',
    uploadButton: '选择文件',
    confirmProductType: '产品类型',
    confirmPackage: '套装方案',
    confirmAreas: '安装部位',
    confirmPhotos: '照片与凭证',
    // 进度与产品信息（依据 docs/zhucezhibao.html 参考页）
    progressVerify: '产品验证',
    progressDetails: '填写质保',
    progressSubmit: '提交审核',
    progressApproval: '管理员批准',
    sectionProductInfo: '产品信息',
    productModel: '产品型号',
    thickness: '厚度',
    material: '材质',
    rollReusable: '可重复登记',
    verifiedBannerTitle: '卷材序列号验证通过',
    verifiedBannerDesc: '产品资料已读取，序列号可重复用于合规登记',
    addAnotherTip: '所有产品均为卷材，序列号可重复用于合规登记，每次批准都会新增独立使用标记。',
    removeProduct: '移除',
    installNotes: '安装备注',
    installNotesPlaceholder: '选填，补充安装情况说明',
    // 隐私与保修确认
    sectionLegal: '隐私与保修确认',
    legalRequired: '2 项必须完成',
    legalIntro: '请分别打开并阅读两份正式文件，在各自窗口底部完成确认。法律正文随界面语言显示中文版或官方英文版。',
    privacyNotice: '隐私声明',
    privacyNoticeDesc: '了解质保登记过程中收集的信息、使用目的、保存方式以及客户权利。',
    warrantyTerms: '保修条款',
    warrantyTermsDesc: '查看产品适用条件、保修范围、除外情形、理赔流程以及安装门店责任。',
    reviewAcknowledge: '查看并确认',
    reviewAccept: '查看并接受',
    reviewAgain: '重新查看',
    notAcknowledged: '尚未确认',
    notAccepted: '尚未接受',
    acknowledged: '已确认',
    accepted: '已接受',
    legalHint: '只有两项都完成确认后，才能提交质保登记。',
    consentPrivacy: '我已阅读并知悉《隐私声明》，并确认已按适用法律向客户提供相关隐私信息。',
    consentWarranty: '我已阅读并接受《保修条款》，并确认登记信息与支持资料完整、准确。',
    confirmAcceptance: '完成确认',
    closeLater: '稍后处理',
    // 草稿
    saveDraft: '保存草稿',
    draftSaved: '草稿已保存',
    draftAutosave: '自动保存已开启',
    draftRestored: '已恢复上次草稿',
    confirmStore: '门店',
    confirmNotes: '安装备注',
    confirmScope: '安装范围'
  },
  warrantyManage: {
    title: '质保档案',
    keywordPlaceholder: '序列号 / 产品型号',
    traceCode: '序列号',
    productName: '产品型号',
    categoryName: '产品类型',
    owner: '车主',
    ownerEmail: '车主邮箱',
    ownerPhone: '车主电话',
    vehicle: '车辆',
    store: '安装门店',
    agentBelong: '所属代理商',
    installDate: '安装日期',
    warrantyPeriod: '质保期限',
    warrantyYears: '质保期限',
    submittedAt: '提交时间',
    detailTitle: '质保详情',
    productInfo: '产品信息',
    ownerInfo: '车主信息',
    vehicleInfo: '车辆信息',
    plateNumber: '车牌号',
    vehicleState: '州/省',
    vinCode: 'VIN',
    brand: '品牌',
    model: '型号',
    installers: '施工人员',
    installerName: '姓名',
    installerRole: '角色',
    workScope: '施工范围',
    stage: '参与阶段',
    reviewNote: '审核备注',
    approve: '通过',
    approveTitle: '批准质保登记',
    approveInstallDate: '核定安装日期',
    installDateHint: '默认取登记时的安装日期，可修正；质保期按此日期起算',
    approveNote: '审核备注',
    approveNotePlaceholder: '选填，将记录到质保记录',
    installDateRequired: '请选择核定安装日期',
    noteRequired: '请填写备注',
    approveSuccess: '已通过',
    reject: '拒绝',
    rejectPrompt: '请填写拒绝原因（将通知登记门店）',
    rejectSuccess: '已拒绝',
    requestRevision: '暂缓审核',
    revisionPrompt: '请填写暂缓审核原因（将通知登记门店）',
    revisionSuccess: '已暂缓审核',
    supplement: '补交资料并重新提交',
    supplementTitle: '补交资料',
    supplementDesc: '请根据暂缓原因补充或修改资料，提交后质保将自动转回「待审核」。',
    supplementAfterRequired: '请至少上传 1 张安装后照片',
    supplementSuccess: '已重新提交，等待管理员审核',
    status: {
      DRAFT: '草稿',
      SUBMITTED: '已提交',
      UNDER_REVIEW: '审核中',
      NEEDS_REVISION: '暂缓审核',
      APPROVED: '已通过',
      REJECTED: '已拒绝',
      CHANNEL_REVIEW: '渠道核验中',
      CANCELLED: '已取消'
    }
  },
  profile: {
    title: '修改邮箱',
    step1: '步骤1：验证当前邮箱',
    step2: '步骤2：输入新邮箱',
    currentEmail: '当前邮箱',
    newEmail: '新邮箱',
    newEmailCode: '新邮箱验证码',
    newEmailPlaceholder: '输入新邮箱地址',
    newEmailCodePlaceholder: '输入新邮箱验证码',
    confirmChange: '确认修改'
  },
  dashboard: {
    overviewTitle: '安装概览',
    overviewSubtitle: '查看安装订单与质保申请进度',
    scopePrefix: '当前范围：',
    scopeStore: '本门店',
    scopeAgent: '本代理商下辖门店',
    scopeAll: '全部门店',
    monthlyOrders: '本月安装订单',
    monthlyOrdersNote: '{month} · 已提交订单',
    todayOrders: '今日安装订单',
    todayOrdersNote: '按安装日期统计',
    totalOrders: '累计安装订单',
    totalOrdersNote: '包含待审核、已激活及未通过订单',
    activeWarranties: '已激活质保',
    activeWarrantiesNote: '审核通过并已激活',
    unitOrders: '笔',
    unitWarranties: '条',
    unitTip: '单位：笔',
    last6Months: '近6个月',
    last12Months: '近12个月',
    monthlyChartTitle: '月度安装订单',
    warrantyStatusTitle: '质保登记状态',
    registeredTotal: '登记记录',
    statusPending: '待审核',
    statusApproved: '已激活',
    statusRejected: '未通过',
    recentTitle: '最近安装订单',
    recentDesc: '按登记时间从新到旧排列',
    viewAll: '查看全部',
    colInstallDate: '安装日期',
    colTraceCode: '产品序列号',
    colOwnerEmail: '车主邮箱',
    colProductModel: '产品型号',
    colStatus: '登记状态',
    colActions: '操作',
    viewDetail: '查看详情',
    footerNote: '提交申请不代表质保已激活，请以登记状态为准。',
    detail: {
      title: '质保登记详情',
      subtitle: '查看申请资料与质保激活进度',
      bannerPendingTitle: '申请已提交，质保尚未激活',
      bannerPendingDesc: '审核通过后激活，请以登记状态为准。',
      bannerApprovedTitle: '质保已激活',
      bannerApprovedDesc: '该登记已审核通过，质保在有效期内。',
      bannerRejectedTitle: '登记未通过',
      bannerRejectedDesc: '该登记未通过审核。',
      reviewNotePrefix: '审核备注',
      sectionApplication: '申请与质保信息',
      submittedAt: '提交时间',
      regStatus: '登记状态',
      warrantyPeriodPending: '{n}年（待激活）',
      warrantyRange: '质保起止日期',
      warrantyRangePending: '待审核通过后确认',
      warrantyRangeHint: '质保起止日期将在审核通过后按品牌规则显示。',
      sectionProduct: '产品与安装信息',
      productModel: '产品型号',
      productType: '产品类型',
      installStore: '安装门店',
      storeCode: '安装门店编号',
      installers: '安装人员',
      sectionOwner: '车主信息',
      ownerPhone: '联系电话',
      notFilled: '未填写',
      sectionVehicle: '车辆信息',
      sectionPhotos: '照片与凭证',
      optionalTag: '全部选填',
      invoices: '订单或凭证',
      beforePhotos: '安装前照片',
      afterPhotos: '安装后照片',
      photoCount: '{n}张',
      notUploaded: '未上传',
      preview: '预览'
    }
  },
  members: {
    title: '车主档案',
    list: '车主档案列表',
    ownerName: '车主姓名',
    ownerNamePlaceholder: '输入车主姓名',
    ownerDetail: '车主档案详情',
    editOwner: '更正车主档案',
    phone: '电话',
    phonePlaceholder: '输入电话',
    vehicleCount: '车辆数',
    warrantyCount: '质保记录数',
    vehicles: '关联车辆',
    warranties: '关联质保记录',
    warrantyPeriod: '质保起止',
    traceCode: '序列号',
    productName: '产品',
    vehicleState: '州/省',
    vinCode: 'VIN码',
    // 以下字段仍供代理商/门店等页面共用
    username: '用户名',
    nickname: '昵称',
    email: '邮箱',
    emailPlaceholder: '输入邮箱',
    usernamePlaceholder: '输入用户名',
    nicknamePlaceholder: '输入昵称',
    agent: '所属代理商',
    store: '施工门店',
    brand: '品牌',
    model: '型号',
    color: '颜色',
    plate: '车牌'
  },
  vehicles: {
    title: '车辆档案',
    list: '车辆档案列表',
    plateNumber: '车牌号',
    vehicleState: '州/省',
    vinCode: 'VIN码',
    brand: '品牌',
    model: '型号',
    owner: '车主',
    ownerEmail: '车主邮箱',
    ownerPlaceholder: '输入车主姓名',
    warrantyCount: '质保记录数',
    vehicleDetail: '车辆档案详情',
    editVehicle: '更正车辆档案',
    vehicleCountry: '签发国家/地区',
    warranties: '关联质保记录',
    warrantyPeriod: '质保起止',
    traceCode: '序列号',
    productName: '产品',
    store: '施工门店',
    agent: '所属代理商',
    platePlaceholder: '输入车牌号',
    vinPlaceholder: '17位VIN码',
    plateExample: '如 京A12345',
    stateExample: '如 加利福尼亚州 / 广东省',
    brandExample: '如 丰田',
    modelExample: '如 凯美瑞',
    countryExample: '如 中国 / 美国'
  },
  agents: {
    title: '代理商管理',
    list: '代理商列表',
    addAgent: '添加代理商',
    editAgent: '编辑代理商',
    agentDetail: '代理商详情',
    country: '国家/地区',
    stores: '门店数',
    members: '会员数',
    emailVerified: '邮箱已验证',
    noStores: '暂无门店',
    storeName: '门店名称',
    keywordPlaceholder: '用户名/昵称',
    countryPlaceholder: '输入国家/地区',
    dealerIdUnchanged: 'Dealer ID 不可更改',
    confirmEnable: '确定{action}此代理商？'
  },
  stores: {
    title: '门店管理',
    list: '门店列表',
    applyStore: '申请新门店',
    editStore: '编辑门店',
    storeCode: '门店编号',
    storeName: '门店名称',
    contactName: '联系人',
    loginEmail: '登录邮箱',
    storeAdminLoginEmail: '门店管理员登录邮箱',
    detailedAddress: '详细地址',
    keywordPlaceholder: '门店名称/编号',
    selectAgent: '选择代理商',
    codePlaceholder: '输入门店编号',
    namePlaceholder: '输入门店名称',
    contactPlaceholder: '输入联系人',
    country: '国家/地区',
    countryPlaceholder: '选择国家/地区',
    confirmDelete: '确定删除此门店？',
    confirmApprove: '确定通过此门店？',
    confirmReject: '确定拒绝此门店？',
    confirmEnable: '确定{action}此门店？'
  },
  storeEmployees: {
    title: '门店员工',
    list: '员工列表',
    addEmployee: '添加员工',
    editEmployee: '编辑员工',
    employeeName: '姓名',
    employeeId: '施工技师编号',
    keywordPlaceholder: '姓名/Installer ID/电话',
    namePlaceholder: '输入员工姓名',
    idPlaceholder: '系统自动生成',
    status: '人员状态',
    statusEnabled: '启用',
    statusDisabled: '禁用',
    phonePlaceholder: '输入联系电话',
    selectStore: '选择门店',
    confirmDelete: '确定删除此员工？'
  },
  products: {
    title: '产品管理',
    list: '产品列表',
    addProduct: '添加产品',
    editProduct: '编辑产品',
    productDetail: '产品详情',
    productName: '产品名称',
    productCode: '产品编码',
    originalPrice: '原价',
    salePrice: '售价',
    costPrice: '成本价',
    profit: '利润',
    warranty: '质保',
    warrantyMonths: '质保（月）',
    thumbnail: '缩略图',
    thumbnailTip: '缩略图地址',
    warrantyDesc: '质保说明',
    applicableModels: '适用车型',
    applicableBrands: '适用品牌',
    detailContent: '详情内容',
    detailSectionDescription: '描述',
    detailSectionWarranty: '质保说明',
    detailSectionModels: '适用车型',
    detailSectionBrands: '适用品牌',
    detailSectionThumbnail: '缩略图',
    keywordPlaceholder: '产品名称/编码',
    namePlaceholder: '输入产品名称',
    codePlaceholder: '输入产品编码',
    typePlaceholder: '选择类型',
    descPlaceholder: '输入产品描述',
    warrantyDescPlaceholder: '输入质保说明',
    modelsPlaceholder: '输入适用车型，逗号分隔',
    brandsPlaceholder: '输入适用品牌，逗号分隔',
    detailPlaceholder: '输入详情内容（支持HTML）',
    thumbnailPlaceholder: '输入图片URL',
    monthsAppend: '个月',
    confirmDelete: '确定删除此产品？',
    confirmToggle: '确定{action}此产品？'
  },
  trace: {
    categories: {
      title: '产品类型管理',
      list: '产品类型列表',
      add: '添加产品类型',
      edit: '编辑产品类型',
      typeCode: '编码',
      typeName: '名称',
      englishName: '英文名称',
      template: '模板',
      warrantyYears: '质保期限',
      codePlaceholder: '如 PPF, COLOR',
      namePlaceholder: '输入产品类型名称',
      englishPlaceholder: '输入英文名称',
      selectTemplate: '选择模板',
      uniqueCodeTip: '唯一编码，不可修改',
      planHint: '方案提示（中文）',
      planHintEn: '方案提示（英文）',
      planHintPlaceholder: '质保登记选择该产品类型后显示的提示',
      planHintEnPlaceholder: '英文提示，可与中文分行显示',
      planHintTip: '用于质保登记页"选择产品类型"后显示的说明文字，留空则显示通用提示',
      allowDuplicate: '允许重复登记',
      allowDuplicateTip: '开启后同一序列号可多次登记质保（卷材可重复用于合规登记，每次批准新增一条独立登记记录）；关闭则同一码只能登记一次',
      showInWarranty: '显示到质保页',
      showInWarrantyTip: '关闭后质保登记页"选择产品类型"不再显示该类型',
      confirmDelete: '确定删除此产品类型？',
      confirmToggle: '确定{action}此产品类型？'
    },
    specifications: {
      title: '产品型号管理',
      list: '产品型号列表',
      add: '添加产品型号',
      edit: '编辑产品型号',
      template: '模板',
      productType: '产品类型',
      productModel: '产品型号',
      modelColorNameCn: '表面/颜色（中文）',
      modelColorNameEn: '表面/颜色',
      fullSpecs: '完整规格',
      productAttributes: '产品属性',
      warrantyYears: '质保期限',
      internalNote: '内部备注',
      uniqueModelTip: '唯一产品型号，创建后不可修改',
      modelInfo: '型号信息',
      selectProductType: '选择产品类型',
      categoryDefaultTip: '留空则使用产品类型默认质保',
      noTemplateHint: '请选择已配置模板的产品类型。',
      generateTraceCodes: '生成序列号',
      agent: '代理商',
      quantity: '数量',
      quantityTip: '每次最多生成 1000 个',
      batchInfo: '批次信息',
      manufactureDate: '生产日期',
      batchNo: '批次号',
      generate: '生成',
      confirmDelete: '确定删除此型号？',
      confirmToggle: '确定{action}此型号？',
      generated: '成功生成 {n} 个序列号'
    },
    codes: {
      title: '我的产品',
      list: '我的产品列表',
      export: '导出',
      traceCode: '序列号',
      productModel: '产品型号',
      product: '产品名称',
      category: '产品类型',
      material: '材质',
      finish: '工艺',
      color: '颜色',
      thickness: '厚度',
      warranty: '质保',
      mfgDate: '生产日期',
      batchNo: '批次',
      batchInternalNote: '批次内部备注',
      token: 'Token',
      distribution: '流转',
      batchNumber: '批次号',
      traceCodePlaceholder: '序列号',
      selectCategory: '选择产品类型',
      selectModel: '选择产品型号',
      selectAgent: '选择代理商',
      productionBatchNumber: '生产批次号',
      internalNoteAdmin: '内部备注（仅管理员可见）',
      noBatchNote: '暂无批次备注',
      detailTitle: '序列号详情',
      publicInfo: '公开信息',
      internalInfo: '内部信息（管理员）',
      supplier: '供应商',
      purchaseDate: '进货日期',
      editNote: '编辑备注',
      editInternalInfo: '编辑内部信息（管理员）',
      editBatchNote: '编辑批次内部备注',
      batchEdit: '批量修改',
      editBatch: '编辑批次',
      createdTime: '生成时间',
      batchEditTitle: '批量修改批次信息',
      copyTitle: '复制序列号',
      batchEditTip: '将对已选的 {n} 条序列号应用以下修改，留空的字段保持不变（已注册的序列号自动跳过）',
      leaveBlankNoChange: '留空则不修改',
      batchEditResult: '成功更新 {n} 条序列号',
      batchEditResultSkipped: '已更新 {updated} 条，跳过 {skipped} 条已注册的序列号',
      supplierName: '供应商名称',
      remarkPlaceholder: '请输入备注',
      enterInternalNote: '请输入内部备注',
      qrCode: '二维码',
      scanTip: '扫码验证真伪',
      noBatchInfo: '暂无批次信息',
      confirmInvalidate: '确定作废此序列号？'
    },
    installationAreas: {
      title: '安装部位管理',
      list: '安装部位列表',
      add: '添加安装部位',
      edit: '编辑安装部位',
      areaCode: '部位编码',
      areaName: '部位名称',
      areaNameEn: '英文名称',
      group: '分组',
      groupBody: '车身覆盖件',
      groupLight: '灯具保护',
      groupOther: '其他',
      packages: '包含套装',
      pkgFull: '全车保护套装',
      pkgFront: '前部保护套装',
      pkgRear: '后部保护套装',
      pkgFullShort: '全车',
      pkgFrontShort: '前部',
      pkgRearShort: '后部',
      bilateral: '涉及左右',
      keywordPlaceholder: '部位名称 / 编码',
      codePlaceholder: '如 FRONT_BUMPER',
      codeRequired: '请输入部位编码',
      codePattern: '编码仅支持大写字母、数字、下划线和连字符',
      nameRequired: '请输入部位名称',
      groupRequired: '请选择分组',
      deleteConfirm: '确定删除部位 "{name}" 吗？'
    },
    packages: {
      title: '套装方案管理',
      list: '套装方案列表',
      add: '添加套装方案',
      edit: '编辑套装方案',
      category: '产品类型',
      selectCategory: '选择产品类型',
      categoryRequired: '请选择产品类型',
      packageCode: '套装编码',
      codePlaceholder: '如 PPF_FULL',
      codeRequired: '请输入套装编码',
      codePattern: '编码仅支持字母、数字、下划线和连字符',
      packageName: '套装名称',
      packageNameEn: '英文名称',
      nameRequired: '请输入套装名称',
      areas: '包含部位',
      noAreas: '暂无启用中的安装部位，请先在安装部位管理中添加',
      autoApply: '自动应用',
      autoApplyTip: '开启后，质保登记选中该产品类型时自动套用本套装',
      keywordPlaceholder: '套装名称 / 编码',
      categoryAreasTitle: '类型可选部位（质保登记 03 候选集）',
      categoryAreasConfigured: '该类型已配置候选部位：未勾选的部位在质保登记 03 步对该类型不可见',
      categoryAreasNotConfigured: '该类型未配置候选部位：质保登记 03 步显示全部启用部位',
      categoryAreasHint: '不勾选任何部位并保存 = 清除配置（显示全部）',
      deleteConfirm: '确定删除套装 "{name}" 吗？'
    },
    template: {
      PPF: {
        name: '漆面保护膜',
        fields: {
          material: { label: '材质', placeholder: '如 TPU' },
          thickness: { label: '厚度', placeholder: '如 7.5MIL' },
          internalNote: { label: '内部备注' }
        }
      },
      TPU_COLOR_PPF: {
        name: 'TPU 改色膜',
        fields: {
          material: { label: '材质', placeholder: '如 TPU' },
          colorCode: { label: '颜色编号', placeholder: '如 SN-P1-001-SG' },
          colorName: { label: '颜色名称', placeholder: '如 柔雾浅粉' },
          thickness: { label: '厚度', placeholder: '如 7.5MIL' },
          internalNote: { label: '内部备注' }
        }
      },
      CUSTOM_PRINTED: {
        name: '定制彩绘膜',
        fields: {
          material: { label: '材质', placeholder: '如 Vinyl' },
          finish: { label: '印刷工艺', placeholder: '如 数码喷绘' },
          colorCode: { label: '基材类型', placeholder: '如 160g PET Vinyl' },
          internalNote: { label: '内部备注' }
        }
      },
      WINDOW_FILM: {
        name: '隔热膜',
        fields: {
          finish: { label: '产品工艺', placeholder: '如 磁控溅射' },
          material: { label: '功能层材料', placeholder: '如 氮化陶瓷' },
          thickness: { label: '厚度', placeholder: '如 2.5 mil' },
          internalNote: { label: '内部备注' }
        }
      },
      VINYL_WRAP: {
        name: '改色膜',
        fields: {
          material: { label: '材质', placeholder: '如 160g PET Vinyl' },
          colorCode: { label: '颜色编号', placeholder: '如 SN-P1-001-SG' },
          colorName: { label: '颜色名称', placeholder: '如 柔雾浅粉' },
          thickness: { label: '厚度', placeholder: '如 6.5MIL' },
          internalNote: { label: '内部备注' }
        }
      },
      HEADLIGHT: {
        name: '大灯模板',
        fields: {
          material: { label: '材质', placeholder: '如 TPU' },
          thickness: { label: '厚度', placeholder: '如 7.5MIL' },
          internalNote: { label: '内部备注' }
        }
      }
    }
  },
  warrantySummary: {
    title: '质保汇总',
    totalProducts: '产品总数',
    registered: '已注册',
    expired: '已过期',
    voided: '已作废',
    storeSummary: '门店质保汇总',
    storeName: '门店名称',
    storeCode: '门店编号',
    active: '质保中'
  },
  myProducts: {
    title: '我的产品',
    traceCode: '序列号',
    traceCodePlaceholder: '请输入序列号',
    productType: '产品类型',
    productTypePlaceholder: '请输入产品类型',
    productModel: '产品型号',
    productModelPlaceholder: '请输入产品型号',
    finishColor: '表面/颜色',
    finishColorPlaceholder: '表面 / 颜色',
    warranty: '质保期限',
    createdAt: '创建时间',
    status: '状态',
    hint: '您只能查看管理员分配给您的产品及流转状态，车主和车辆资料已被隐藏。'
  },
  cms: {
    title: '网站页面',
    list: '页面列表',
    addPage: '添加页面',
    editPage: '编辑页面',
    pageCode: '页面代码',
    pageTitle: '标题',
    seoDescription: 'SEO 描述',
    seoKeywords: 'SEO 关键词',
    content: '内容',
    codePlaceholder: '如 services, about',
    titlePlaceholder: '页面标题',
    descPlaceholder: 'SEO 描述',
    keywordsPlaceholder: 'keyword1, keyword2',
    contentPlaceholder: 'HTML 内容',
    confirmDelete: '确定删除此页面？'
  },
  settings: {
    title: '系统设置',
    site: '网站',
    contact: '联系方式',
    email: '邮件',
    sms: '短信',
    order: '订单',
    siteName: '网站名称',
    siteLogo: '网站Logo',
    siteDescription: '网站描述',
    siteKeywords: '网站关键词',
    icpNumber: '备案号',
    companyName: '公司名称',
    serviceHotline: '服务热线',
    contactEmail: '联系邮箱',
    businessHours: '营业时间',
    companyAddress: '公司地址',
    smtpServer: 'SMTP 服务器',
    smtpPort: 'SMTP 端口',
    smtpUsername: 'SMTP 用户名',
    smtpPassword: 'SMTP 密码',
    fromEmail: '发件邮箱',
    fromName: '发件人',
    enableSsl: '启用 SSL',
    smsProvider: '短信服务商',
    selectProvider: '选择服务商',
    aliyunSms: '阿里云短信',
    tencentSms: '腾讯云短信',
    twilio: 'Twilio',
    accessKeyId: 'Access Key ID',
    accessKeySecret: 'Access Key Secret',
    smsSign: '短信签名',
    templateCode: '模板代码',
    defaultWarrantyDays: '默认质保天数',
    reminderDaysBeforeExpiry: '到期提醒天数',
    autoArchiveAfterDays: '自动归档天数',
    enableSmsNotification: '启用短信通知',
    enableEmailNotification: '启用邮件通知',
    saveSettings: '保存设置',
    siteNamePlaceholder: '输入网站名称',
    logoPlaceholder: '输入Logo地址',
    descPlaceholder: '输入网站描述',
    icpPlaceholder: '输入备案号',
    companyPlaceholder: '输入公司名称',
    hotlinePlaceholder: '输入服务热线',
    emailPlaceholder: '输入联系邮箱',
    hoursPlaceholder: '如 9:00-18:00',
    addressPlaceholder: '输入公司地址',
    smtpServerPlaceholder: '如 smtp.gmail.com',
    smtpPortPlaceholder: '如 587',
    smtpUsernamePlaceholder: '输入SMTP用户名',
    smtpPasswordPlaceholder: '输入SMTP密码',
    fromEmailPlaceholder: '如 noreply@example.com',
    fromNamePlaceholder: '输入发件人',
    accessKeyPlaceholder: '输入Access Key',
    accessSecretPlaceholder: '输入Access Secret',
    smsSignPlaceholder: '输入短信签名',
    templateCodePlaceholder: '输入模板代码'
  }
}
